<template>
  <div class="nav-wrapper">
    <ul class="menu">
      <li class="menu-item" v-for="(item, index) in data" :key="index" :class="{'active':currentMenuId==item.id}"
          @click="menuClick(item,index)">
        <span>{{item.name}}</span>
        <img class="m-l-5" v-show="item.children" src="../../assets/img/header/arrow.png">
        <div v-if="item.children" class="nav-item-container">
          <nav-item v-for="(citem, cindex) in item.children" :key="cindex" :data="citem" :layer="1"
                    @pageSkip="pageSkip(item.id,item.path)"></nav-item>
        </div>
      </li>
      
    </ul>
    <span class="lang-switch" @click="switchLang" title="切换中文版">
      <span class="lang-text">中</span>
      <span class="lang-divider">/</span>
      <span class="lang-text active-lang">EN</span>
    </span>
  </div>
</template>

<script>
  import NavItem from "./NavItem";

  export default {
    name: "NavMenu",
    components: {NavItem},
    props: {
      data: Array,
    },
    watch: {
      data(newVal, oldVal) {
        this.currentMenuId = this.getMenuIdByPath(newVal, this.$store.state.currentPath);
      }
    },
    created() {
    },
    data() {
      return {
        currentMenuIndex: 0,
        currentMenuId: Number,
      };
    },
    methods: {
      switchLang() {
        window.open('https://www.xktech.com', '_blank');
      },
      menuClick(route, index) {
        this.currentMenuIndex = index;
        if (route.path) {
          if (this.$router.currentRoute.path !== route.path) {
            if (route.path.indexOf("http") != -1) {
              window.open(route.path, "_blank");
            }
            else {
              this.$router.push({path: route.path});
              this.currentMenuId = route.id;
              this.saveState(route.path);
            }
          }
        }
      },
      pageSkip(id, path) {
        this.currentMenuId = id;
        this.saveState(path);
      },
      saveState(id) {
        this.$store.commit('updateCurrentPath', id);
      },
      getMenuIdByPath(data, path) {
        if (!data) {
          return -1;
        }
        for (let route of data) {
          if (route.path === path) {
            return route.id;
          }
          if (route.children && this.isChildPath(route.children, path)) {
            return route.id;
          }
        }
        return -1;
      },

      isChildPath(children, path) {
        return children.some((route) => {
          if (route.path === path) {
            return true;
          }
          return route.children && this.isChildPath(route.children, path);
        });
        return false;
      }
    }
  }

</script>

<style>
  .menu-item {
    position: relative;
  }

  .pc-box .menu-item .nav-item-container {
    position: absolute;
    top: 100%;
    left: 50%;
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    height: auto;
    background: rgba(255, 255, 255, .95);
    font-weight: bold;
    min-width: 220px;
    padding: 10px 0;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
  }

  .pc-box .menu {
    /*display: flex;*/
    /*justify-content: space-between;*/
    cursor: pointer;
    text-align: center;
  }

  .pc-box .menu-item {
    line-height: 43px;
    font-size: 16px;
    color: white;
    display: inline-block;
    margin-left: 6px;
    letter-spacing: 1px;
    padding: 0 25px;
    position: relative;
  }

  .pc-box .menu-item:hover > span {
    /* font-weight: bold; */
    /* color: #f45909; */
  }

  .pc-box .menu-item > img {
    margin: auto 0;
    display: inline-block;
    position: absolute;
    transform: translate(-50%, -50%);
    right: 0px;
    top: 50%;
  }

  .pc-box .menu-item:hover .nav-item-container {
    opacity: 1;
    visibility: visible;
    transition: opacity .3s ease;
    width: auto;
    min-width: 220px;
  }

  .pc-box .nav-item-container {
    visibility: hidden;
    opacity: 0;
    border-radius: 4px;
    padding: 0;
    color: hsla(0, 0%, 100%, .8);
    font-size: 15px;
    text-align: left;
    width: auto;
    min-width: 220px;
    color: rgba(0, 0, 0, .5);
  }

  .pc-box .active {
    background: url("../../assets/img/header/under_line.png");
    background-repeat: no-repeat;
    background-position: center 40px;
  }

  .pc-box .menu .menu-item:hover {
    background-image: url("../../assets/img/header/under_line.png");
    background-repeat: no-repeat;
    background-position: center 40px;

  }

  /*.pc-box .menu .menu-item:hover >span{*/
  /*position: relative;*/
  /*}*/
  .pc-box .menu .menu-item:hover > img {
    transform: rotate(-180deg);
    transform-origin: 3px 3px;
    transition: transform .3s ease;
    opacity: 1;
    display: inline-block;
    /*margin-top: -6px;*/
    /*margin-left: -6px;*/
  }

  .rotate180 {
    transform: rotate(-180deg);
    transition: transform .3s ease;
    opacity: 1;
    display: block;
  }

  /* 语言切换按钮 */
  .nav-wrapper {
    display: inline-flex;
    align-items: center;
  }

  .nav-wrapper .menu {
    display: inline-flex;
    align-items: center;
  }

  .lang-switch {
    display: inline-flex;
    align-items: center;
    margin-left: 16px;
    padding: 2px 0;
    cursor: pointer;
    line-height: 43px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    letter-spacing: 0.5px;
    user-select: none;
    transition: color 0.25s ease;
  }

  .lang-switch:hover {
    color: #fff;
  }

  .lang-divider {
    margin: 0 3px;
    color: rgba(255, 255, 255, 0.35);
  }

  .lang-text {
    transition: color 0.25s ease, font-weight 0.25s ease;
  }

  .lang-text.active-lang {
    color: #fff;
    font-weight: bold;
  }

  .lang-switch:hover .lang-text {
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/NavMenu/NavMenu.vue